import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  helperText: {
    marginBottom: theme.spacing(1),
  },

  jobRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: `${theme.spacing(1.5)}px ${theme.spacing(1)}px`,
    cursor: "pointer",

    "&:hover": {
      backgroundColor: theme.palette.background.default,
    },

    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  warningText: {
    color: "#f44336",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
}));
